import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router keeps the window scroll offset across route changes: opening a
// page while scrolled half-way down another one drops you into the middle of
// the new page. This resets to the top on every navigation.
//
// Exception: a URL carrying a #section anchor is left alone, so the homepage's
// hash links (SmartLink -> /#partners) still land on their section.
//
// useLayoutEffect, not useEffect, so the reset happens before the browser
// paints — otherwise the wrong scroll position is visible for a frame.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  // Browsers restore the previous offset on reload and on back/forward. That
  // fights the reset below, so hand scroll control to the app.
  useLayoutEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
